import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AuthenticationService } from 'beyond-util';

import { environment } from '../../environments/environment';
import { EndpointTypes } from '../enums/enpoint-types.enum';
import { FormCode } from '../enums/form-code.enum';
import { FormName } from '../enums/form-name.enum';

@Injectable()
export class BackendService {
  private _url: string = environment.apiUrl;
  private _gatewayUrl = `${this._url}/Gateway`;
  private _gatewayGetUrl = `${this._gatewayUrl}Get`;
  private _gatewayPostUrl = `${this._gatewayUrl}Post`;
  private _gatewayPutUrl = `${this._gatewayUrl}Put`;
  private _gatewayDeleteUrl = `${this._gatewayUrl}Delete`;
  private _mpGatewayUrl: string = environment.mediaPlanApiUrl;

  constructor(
    private _http: HttpClient,
    private _authenticationService: AuthenticationService
  ) {}

  fetchMenu(): Observable<any> {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      token: this._authenticationService.getToken(),
    });

    return this._http.get(`${this._url}/Menu`, { headers });
  }

  fetchSettings(
    formCode: FormCode,
    formName: FormName,
    endPointType: EndpointTypes,
    filter: string = '',
    entityId?: number,
    skipSettings: boolean = false
  ): Observable<any> {
    const requestParams = this.getRequestParams(
      formCode,
      formName,
      endPointType,
      filter,
      entityId,
      skipSettings
    );

    return this._http.get(this._gatewayGetUrl, requestParams);
  }

  save(
    formCode: FormCode,
    formName: FormName,
    data: any,
    skipSettings: boolean = false
  ) {
    let skip = '';
    if (skipSettings) {
      skip = `&skipSettings=${skipSettings}`;
    }

    return this._http.post(
      `${this._gatewayPostUrl}?formCode=${formCode}&formName=${formName}${skip}`,
      data
    );
  }

  update(formCode: FormCode, formName: FormName, data: any) {
    return this._http.put(
      `${this._gatewayPutUrl}?formCode=${formCode}&formName=${formName}`,
      data
    );
  }

  delete(formCode: FormCode, formName: FormName, id: any) {
    return this._http.delete(
      `${this._gatewayDeleteUrl}?formCode=${formCode}&formName=${formName}&entityId=${id}`
    );
  }

  fetchMediaPlanSettings(payload) {
    return this._http.post(this._mpGatewayUrl, payload);
  }

  getRequestPayload(
    formCode: FormCode,
    formName: FormName,
    endpointType: EndpointTypes,
    filterString: string = null,
    entity: Object = null,
    entityGUids: Object = null,
    skipSettings: boolean = false
  ) {
    return {
      FormCode: formCode,
      FormName: formName,
      EndpointType: endpointType,
      FilterString: filterString,
      Entity: entity,
      EntityGuids: entityGUids,
      SkipSettings: skipSettings,
    };
  }

  getRequestParams(
    formCode: string,
    formName: string,
    endPointType: EndpointTypes,
    filter: string,
    entityId?: number,
    skipSettings: boolean = false
  ) {
    const params = {
      formCode,
      formName,
      endPointType,
    };

    if (entityId) {
      params['entityId'] = entityId;
    }

    if (skipSettings) {
      params['skipSettings'] = skipSettings;
    }

    const headers = new HttpHeaders({
      Filters: filter,
    });

    return { params, headers };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/backend.service.ts